import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControl from 'Components/UI/Meta/MetaControl';
import fr from 'facet-rest';
import BaseOverride from 'Overrides/OnboardingStep/BaseOverride';
import useResource from 'Hooks/useResource';
import useDebounce from 'Hooks/useDebounce';
import { useSnackbarContext } from 'Context/SnackbarContext';

const styles = () => ({
  textContent: {
    height: 'fit-content',
  },
});

const JustificationInput = ({ className, classes, ruleResultResource }) => {
  const { resource, setAttribute } = useResource(ruleResultResource);
  const [currentResource, setCurrentResource] = useState(ruleResultResource);
  const { displaySuccess, displayErrorMessage } = useSnackbarContext();

  const submitJustification = async (value) => {
    try {
      currentResource.attr('justification', value);
      const updatedResource = await currentResource.submit();
      setCurrentResource(updatedResource.resources().head());
      displaySuccess('Justification auto-saved successfully');
    } catch (e) {
      displayErrorMessage(e, 'Error submitting justification');
    }
  };

  const applyAutoSave = useDebounce(async (value) => {
    await submitJustification(value);
  }, 750);

  const justificationOverride = fr.metaOverride({ base: BaseOverride })
    .nameOverride('justification', { multiline: true, _hideLabel: true, rows: 3 });

  return (
    <MetaControl
      className={classNames(classes.textContent, className)}
      attrName="justification"
      resource={resource}
      metaOverrideSet={justificationOverride}
      onChange={v => {
        setAttribute('justification', v);
        applyAutoSave(v);
      }}
      placeholder={resource.attr('placeholderText') ? resource.attr('placeholderText') : 'I am overriding because...'}
      fullWidth
      test="facet-plan-linter-rule-justification"
    />
  );
};

JustificationInput.defaultProps = {
  className: '',
};

JustificationInput.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  ruleResultResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(JustificationInput);
